module.exports = __webpack_public_path__ + "static/media/jeanjacquesvossen.68d25064.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jeanjacquesvossen.webp
// module id = 537
// module chunks = 0